import axios, { RawAxiosRequestHeaders } from 'axios'
import { getUrl } from '@reapitform/hooks'

export interface IFormStepData {
  stepDisplayName: string
  stepDescription: string
  stepNumber: number
  stepDisplayNumber: number
  stepDisplayTotal: number
  nextStep: number
  previousStep: number
  continueButtonText: string
  totalCards: number
  showHelp: boolean
  showRequestChange: boolean
  hasChangeRequest: boolean
  continueButtonEnabled: boolean
}

export const getStepData = async (recipientId: string, stepId: string) => {
  const url = getUrl(`/api/recipient/${recipientId}/Step`, { step: stepId })()
  const reqHeaders: Partial<RawAxiosRequestHeaders> = { Accept: 'application/json' }

  const req = await axios.get<IFormStepData>(url, {
    headers: reqHeaders,
  })
  return req.data
}
